import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import PayPalSubscription from './PayPalSubscription';

const TrialModal = ({ isOpen, onClose, planData }) => {
  const { t } = useTranslation();

  if (!planData) {
    return null;
  }

  const trialFeatures = [
    {
      icon: '🔓',
      title: t('subscription.trial.modal.feature1.title'),
      description: t('subscription.trial.modal.feature1.description')
    },
    {
      icon: '⚡',
      title: t('subscription.trial.modal.feature2.title'),
      description: t('subscription.trial.modal.feature2.description')
    },
    {
      icon: '🎯',
      title: t('subscription.trial.modal.feature3.title'),
      description: t('subscription.trial.modal.feature3.description')
    },
    {
      icon: '📞',
      title: t('subscription.trial.modal.feature4.title'),
      description: t('subscription.trial.modal.feature4.description')
    }
  ];

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={t('subscription.trial.modal.title')}
      className="trial-modal"
    >
      <div className="trial-modal-content">
        <div className="trial-highlight">
          <div className="trial-price-highlight">
            <span className="trial-price">{planData.price}</span>
            <span className="trial-period">{t('subscription.trial.period')}</span>
          </div>
          <p className="trial-duration">{t('subscription.trial.modal.duration')}</p>
        </div>

        <div className="trial-features-section">
          <h4 className="features-title">{t('subscription.trial.modal.whatYouGet')}</h4>
          <div className="trial-features-grid">
            {trialFeatures.map((feature, index) => (
              <div key={index} className="trial-feature-item">
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-content">
                  <h5 className="feature-title">{feature.title}</h5>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="trial-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">✅</span>
            <span>{t('subscription.trial.modal.benefit1')}</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✅</span>
            <span>{t('subscription.trial.modal.benefit2')}</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✅</span>
            <span>{t('subscription.trial.modal.benefit3')}</span>
          </div>
        </div>

        <div className="trial-payment-section">
          <h4 className="payment-title">{t('subscription.trial.modal.paymentTitle')}</h4>
          
          <div className="trial-note-box">
            <p>{t('subscription.trial.modal.paymentNote')}</p>
          </div>

          <div className="paypal-section">
            <PayPalSubscription 
              planId="P-TRIAL-7DAY-PLAN-ID"
              onSuccess={(subscriptionID) => {
                alert(`7天试用开始！订阅ID: ${subscriptionID}`);
                onClose();
              }}
              onError={(error) => {
                console.error('试用订阅失败:', error);
                alert('试用订阅过程中发生错误，请重试或联系客服。');
              }}
            />
          </div>

          <div className="modal-actions">
            <button className="modal-button secondary" onClick={onClose}>
              {t('subscription.modal.cancel')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TrialModal;